// User.ts
import { UtilityService }                   from '../_service/utility.service';

export default class User {
    id          : Number;
    username    : String;
    password    : String;
    first_name  : String;
    email       : String;
    last_name   : String;
    is_staff    : Boolean;
    is_active   : Boolean;
    is_superuser: Boolean;
    groups      : [];
    permissions : [];
    date_joined           : Number;
    date_joined_formatted : String;

    complete_name : String = "";
    
    fiscal_code : String;

    constructor(dict = null)
    {
      if (dict !== null)
      {
        this.id                     = dict["id"]            || null;
        this.username               = dict["username"]      || null;
        this.password               = dict["password"]      || null;
        this.first_name             = dict["first_name"]    || null;
        this.last_name              = dict["last_name"]     || null;
        this.is_staff               = dict["is_staff"]      || null;
        this.is_active              = dict["is_active"]     || null;
        this.is_superuser           = dict["is_superuser"]  || null;
        this.groups                 = dict["groups"]        || null;
        this.permissions            = dict["permissions"]   || null;
        this.date_joined            = dict["date_joined"]   || null;
        this.fiscal_code            = dict["fiscal_code"]   || null;
        this.email                  = dict["email"]         || null;
        this.date_joined_formatted  = UtilityService.timestamp_to_date(this.date_joined);
        this.complete_name          = (this.first_name !== "") ? this.last_name+" "+this.first_name : this.username;

      }
    }

  }
